import React from 'react';

import { ActionIcon, Box, Group, Text, createStyles, useMantineTheme } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { AthleteAppointmentWithAthlete } from 'types';

const useStyles = createStyles(theme => ({
  row: {
    display: 'grid',
    alignItems: 'center',
    padding: theme.spacing.xs,
    gridTemplateColumns: 'auto auto min-content',
    gridTemplateRows: 'auto',
    gap: theme.spacing.sm,
    borderTop: `1px solid ${theme.colors.gray[3]}`,
  },
}));

interface ILateCancelAthletesProps {
  athleteAppointment: AthleteAppointmentWithAthlete;
  index: number;
  handleDeleteModal: (id: string) => void;
  permission?: boolean;
}

const LateCancelNoShowAthlete = ({
  athleteAppointment,
  index,
  handleDeleteModal,
  permission = true,
}: ILateCancelAthletesProps): JSX.Element => {
  const theme = useMantineTheme();
  const { classes } = useStyles();
  const navigate = useNavigate();

  const handleNameClick = (): void => {
    navigate(`/users/athletes/${athleteAppointment.athlete.athleteId}/general-info`);
  };

  return (
    <Box className={classes.row}>
      <Group>
        <Text c='dimmed' size='sm'>
          {index + 1}
        </Text>
        <Text
          fw='bold'
          size='sm'
          underline
          sx={{ cursor: 'pointer', width: 'fit-content' }}
          onClick={() => handleNameClick()}
        >
          {athleteAppointment.athlete.firstName} {athleteAppointment.athlete.lastName}
        </Text>
      </Group>
      {athleteAppointment.isLateCancel && <Text c='dimmed'>Late Cancel</Text>}
      {athleteAppointment.isNoShow && <Text c='dimmed'>No Show</Text>}
      <ActionIcon
        onClick={() => handleDeleteModal(athleteAppointment.athleteAppointmentId)}
        variant='transparent'
        color='gray.7'
        disabled={!permission}
      >
        <IconTrash size={theme.fontSizes.xl} />
      </ActionIcon>
    </Box>
  );
};

export default LateCancelNoShowAthlete;
